export default [
    {//首页
        path: '/',
        redirect: "/square",
        component: function (resolve) {
            require(['./Layout.vue'], resolve);
        },
        children: [
            {
                path: '/square',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
                    {//推广
                        path: '/tuiguang',
                        component: function (resolve) {
                            require(['./square.vue'], resolve);
                        },
                    },
            {
                path: '/creation',
                component: function (resolve) {
                    require(['./creation.vue'], resolve);
                }
            },
            {
                path: '/favorites',
                component: function (resolve) {
                    require(['./favorites.vue'], resolve);
                }
            },
            {
                path: '/inventory',
                component: function (resolve) {
                    require(['./inventory.vue'], resolve);
                }
            },
            {
                path: '/invite',
                component: function (resolve) {
                    require(['./invite.vue'], resolve);
                }
            },
            {// 会员中心
                path: '/member',
                component: function (resolve) {
                    require(['./member.vue'], resolve);
                }
            },
            {
                path: '/mine',
                component: function (resolve) {
                    require(['./mine.vue'], resolve);
                }
            },
            {
                path: '/info',
                component: function (resolve) {
                    require(['./info.vue'], resolve);
                }
            },
            {
                path: '/tool',
                component: function (resolve) {
                    require(['./tool.vue'], resolve);
                }
            },
            {
                path: '/toollist',
                component: function (resolve) {
                    require(['./tool_list.vue'], resolve);
                }
            },
            {
                path: '/comeBeautiful',
                component: function (resolve) {
                    require(['./comeBeautiful.vue'], resolve);
                }
            },
            {
                path: '/reqrefund',
                component: function (resolve) {
                    require(['./reqrefund.vue'], resolve);
                }
            },
        ]
    },
    {//联系我们
        path: '/contact2',
        component: function (resolve) {
            require(['./contact2.vue'], resolve);
        },

    },
    {//绘画详情
        path: '/drawDetail',
        component: function (resolve) {
            require(['./drawDetail.vue'], resolve);
        },
    },
    {//绘画详情
        path: '/loginok',
        component: function (resolve) {
            require(['./Loginsuccess.vue'], resolve);
        },
    },
    {//联系我们
        path: '/linkus',
        component: function (resolve) {
            require(['./linkus.vue'], resolve);
        },
    },

]